<template>
  <v-main>
    <AppBar v-if="!hideAppBar" :hide-background="isTypeSound">
      <template #end>
        <v-btn icon plain :ripple="false" class="me-n3" @click="libraryLike()">
          <i class="cu-icon-interest" :class="{ 'on' : heartOn }" :style="{ opacity : (heartOn) ? '1' : '.5'}"></i>
        </v-btn>
      </template>
    </AppBar>
    <Loading :isLoading="isLoading" />
    <NoData v-if="!isLoading && (!currentView || !resultData)" />
    <component v-else
               :is="currentView"
               :resultData="resultData"
    />
  </v-main>
</template>
<script>
import store from '@/store'
import Heart from '@/components/icons/Heart'
export default {
  name: 'LibraryView',
  components: {
    Heart,
    'type01': () => import('./LibrarySound'),
    'type02': () => import('./LibraryWebzine'),
    'type03': () => import('./LibraryWebzineCards'),
    'type04': () => import('./LibraryTIP'),
    'type05': () => import('./LibraryVideo')
  },
  data: () => ({
    isLoading: false,
    resultData: null,
    heartOn: false
  }),
  computed: {
    libNo () {
      if (this.$route.query.libNo !== undefined) {
        return this.$route.query.libNo
      } else if (this.$route.params.libNo !== undefined) {
        return this.$route.params.libNo
      } else {
        return null
      }
    },
    currentView () {
      if (this.resultData) return `type${this.resultData.type}`
      return null
    },
    isView () { // 일반상세
      return this.$route.params.area === 'view'
    },
    isSolution () { // 유닛형
      return this.$route.params.area === 'solution'
    },
    hideAppBar () {
      return this.isSolution
      // return this.$route.path.includes('/solution/') || this.$route.path.includes('SolutionModal')
    },
    isTypeSound () {
      return this.currentView === 'type01'
    }
  },
  created () {
    this.getDetail(this.libNo)
  },
  mounted () {
    this.cntUpdate(this.libNo)
  },
  methods: {
    async getDetail (libNo) {
      this.isLoading = true
      await store.dispatch('getLibraryDetailOne', this.$_payload({'libNo': libNo}))
        .then(res => {
          if (res.success) {
            this.resultData = res.data;
            this.heartOn = this.resultData.likeCnt > 0
          } else {
            this.resultData = null
          }
        })
        .catch(error => {
          console.error(error)
          this.resultData = null
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async cntUpdate (libNo) {
      await store.dispatch('setInqCount', this.$_payload({'libNo': libNo}, {}))
        .then(res => {
          if (!res.success) {
            console.log(res.msg)
          }
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {})
    },
    async libraryLike (libNo = this.libNo) {
      await store.dispatch('setLibraryLike', this.$_payload({'libNo': libNo}, {}))
          .then(res => {
            if (res.success) {
              if (res.data === 'delete') {
                this.heartOn = false
                this.$root.$children[0].$refs.content.$emit('deleteMemberBadgePoss', 4,1)
              } else {
                this.heartOn = true
                this.setMemberAlarm('관심있는 컨텐츠가 저장되었어요. 또 어떤 보석같은 컨텐츠가 있을까요?')
                this.$root.$children[0].$refs.content.$emit('insertMemberBadgePoss', 4,4)
              }
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {})
    },
    async setMemberAlarm (content) {
      await store.dispatch('setMemberAlarm', this.$_payload('inData',{
              content: content
          }))
          .then(() => {
            // console.log('setMemberAlarm : ', res)
          })
          .catch(error => {
          console.error(error);
          })
          .finally(() => {})
    },
  }
}
</script>
